import React, { useState } from 'react';
import {useTranslation} from 'react-i18next';
import { Button } from 'react-bootstrap';
import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { ApiProvider } from '../providers/apiProvider';
import { useParams } from 'react-router-dom';

const ValidatePhoneNumber = () => {
    const {t} = useTranslation();
    const {instance, accounts} = useMsal();
    const _api = new ApiProvider(instance, accounts[0]);
    const associateId = useParams().associateId;

    const [validated, setValidated] = useState(false);
    const [failedValidation, setFailedValidation] = useState(false);

    useEffect(()=>{

        const verify = async () => {
            const response = await _api.Post(`associate/setverified?associateIdentifier=${associateId}`);
            setValidated(true);
            if (response.error != null) {
                console.log(response.error);
                setFailedValidation(true);
            }
        }

        if (!validated) {
            verify();
        }
    }, [associateId])

    function closeWindow(){
        window.close();
    }

    return (
        <div className='d-flex justify-content-center'>
            <div className='mt-4'>
                {validated ?  
                <>
                    <div>
                        {failedValidation ? t("NumberNotValidated") : t("NumberValidated")}
                    </div>
                    <Button onClick={closeWindow}>
                        {t("Close")}
                    </Button>
                </> :
                    <div>
                        {t("NumberValidationPending")}
                    </div>
                }
            </div>
        </div>
    )
}

export default ValidatePhoneNumber;